module.exports = __webpack_public_path__ + "static/media/blog-vector1.a9d74934.svg";